function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2707_39423)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 22C4.91925 22 0 17.058 0 11C0 4.94203 4.91925 0 11 0C17.0807 0 22 4.94203 22 11C22 17.058 17.058 22 11 22ZM11 1.34369C5.67081 1.34369 1.36646 5.67081 1.36646 11C1.36646 16.3292 5.69358 20.6335 11 20.6335C16.3064 20.6335 20.6335 16.3064 20.6335 11C20.6335 5.67081 16.3064 1.34369 11 1.34369Z",
  fill: "#1C1C1C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1135 5.14697C9.04108 5.14697 7.33301 6.83227 7.33301 8.92751C7.33301 9.26913 7.6063 9.54242 7.94791 9.54242C8.28953 9.54242 8.56282 9.26913 8.56282 8.92751C8.56282 7.5155 9.70154 6.37679 11.1135 6.37679C12.5256 6.37679 13.6643 7.5155 13.6643 8.92751C13.6643 10.3395 12.5256 11.4782 11.1135 11.4782C10.7719 11.4782 10.4986 11.7515 10.4986 12.0931V13.9379C10.4986 14.2795 10.7719 14.5528 11.1135 14.5528C11.4552 14.5528 11.7285 14.2795 11.7285 13.9379V12.6397C13.5276 12.3437 14.8941 10.795 14.8941 8.90474C14.8941 6.83227 13.2088 5.14697 11.1135 5.14697Z",
  fill: "#1C1C1C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9789 16.4201C11.9789 16.898 11.5915 17.2855 11.1135 17.2855C10.6354 17.2855 10.248 16.898 10.248 16.4201C10.248 15.9422 10.6354 15.5547 11.1135 15.5547C11.5915 15.5547 11.9789 15.942 11.9789 16.4201Z",
  fill: "#1C1C1C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2707_39423"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white"
})));

function SvgIcContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContact);
export default __webpack_public_path__ + "static/media/ic_contact.918581275d6e9b0a854fba7cb0447560.svg";
export { ForwardRef as ReactComponent };